import * as React from "react";
import type { SVGProps } from "react";
const SvgAddSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M15.6 12H12m0 0H8.4m3.6 0v3.6m0-3.6V8.4M21.6 6v12a3.6 3.6 0 0 1-3.6 3.6H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6Z"
    />
  </svg>
);
export default SvgAddSquare01;
